module.exports = __webpack_public_path__ + "22eeb638511c4c2648df06d903e92001.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/dirty-fightin.webm
// module id = 629
// module chunks = 0